module.exports = __webpack_public_path__ + "media/assets/icons/search-grey-01e303e79cf1be46623854530a7825ea.svg";